import { submitForm } from '../../../../../util'

export type ExportFileType = 'CSV' | 'XML' | 'XLSX'
export interface FormData {
  name: string
  value: string
}

export const exportLibraryData = (
  fileType: ExportFileType,
  formData: FormData[],
  baseURL: string,
  applicationID?: string
) => {
  const data = [...formData, { name: 'exportFileType', value: fileType }]

  const hasAppsProp = () => data.filter((obj) => obj.name === 'apps').length > 0

  if (applicationID && !hasAppsProp()) {
    data.push({ name: 'apps', value: applicationID })
  }

  submitForm(`${baseURL}`, data)
}
